export default "__VITE_ASSET__CvwgQ75P__"